


document.addEventListener("DOMContentLoaded", function () {
    function updatePrices(modal = false) {
        // Select the price element
        const priceElement = modal 
            ? document.querySelector('.modal-content .price') // For Quick Shop modal
            : document.querySelector('#current-price .price'); // For main product page

        if (!priceElement) {
            console.error("Price element not found.");
            return;
        }

        // Get the price directly from the element (check data-price or price text)
        let price = parseFloat(priceElement.innerText.replace(/[^0-9.]/g, ""));
        if (isNaN(price)) {
            console.error("Invalid price value.");
            return;
        }
        console.log("Current Price:", price);

        // Select the radio button for variant selection (modal or main page)
        const selectedRadioButton = modal 
            ? document.querySelector('.modal-content input[type="radio"]:checked')
            : document.querySelector('input[type="radio"]:checked');

        if (!selectedRadioButton) {
            console.error("No radio button is selected.");
            return;
        }

        // Get the quantity (size) from the selected variant (radio button)
        const quantity = parseInt(selectedRadioButton.value);
        console.log("Selected Size (ml):", quantity);

        // Check if the price is coming from the data-price attribute
        const selectedPrice = selectedRadioButton.getAttribute("data-price");
        if (selectedPrice) {
            price = parseFloat(selectedPrice); // Update the price from data-price if available
        }

        if (isNaN(price) || isNaN(quantity) || quantity <= 0) {
            console.error("Invalid price or quantity.");
            return;
        }

        const pricePerMl = price / quantity; // Calculate price per ml
        const perMlElement = modal 
            ? document.querySelector('.modal-content #per-ml-price')
            : document.querySelector("#per-ml-price");

        if (perMlElement) {
            perMlElement.innerHTML = `$${pricePerMl.toFixed(2)}`; // Update the price per ml
            console.log("Price Per ml:", pricePerMl.toFixed(2));
        } else {
            console.error("Price per ml element not found.");
        }
    }

    // Run updatePrices when the page loads
    updatePrices();

    // Event listener for variant selection (handles both modal and main page)
    document.addEventListener("change", function (event) {
        if (event.target.matches('input[type="radio"]')) {
            const isModal = event.target.closest('.modal-content') !== null;
            updatePrices(isModal); // Update based on whether it's the Quick Shop modal or main page
        }
    });

    // When the Quick Shop modal is opened, update prices
    document.addEventListener("click", function (event) {
        if (event.target.matches(".quick-shop-button")) {
            setTimeout(() => {
                updatePrices(true); // After modal content loads, update prices
            }, 500); // Delay to ensure modal content has loaded
        }
    });
});



// document.addEventListener("DOMContentLoaded", function () {
//     function updatePerUnitPrice(isModal = false) {
//         const context = isModal ? document.querySelector('.modal-content') : document;

//         let priceElement = context.querySelector("#current-price .price");
//         let discountPriceElement = context.querySelector("#discount-price #per-unit-price");

//         let selectedRadioButtons = context.querySelectorAll('input[type="radio"]:checked');
//         let allRadioButtons = context.querySelectorAll('input[type="radio"]');

//         if (priceElement && discountPriceElement) {
//             let price = parseFloat(priceElement.innerText.replace(/[^0-9.]/g, ""));
//             if (isNaN(price)) {
//                 console.error("Invalid price value.");
//                 return;
//             }

//             let quantity = null;

//             // Step 1: Check selected radio buttons
//             selectedRadioButtons.forEach((radio) => {
//                 let selectedText = radio.value;
//                 if (!selectedText.includes('"') && !selectedText.includes('x')) {
//                     let quantityMatch = selectedText.match(/\d+/);
//                     if (quantityMatch) {
//                         quantity = parseInt(quantityMatch[0]);
//                     }
//                 }
//             });

//             // Step 2: If no quantity found, check other radios
//             if (!quantity) {
//                 for (let radio of allRadioButtons) {
//                     let variantText = radio.value;
//                     if (!variantText.includes('"') && !variantText.includes('x')) {
//                         let match = variantText.match(/\d+/);
//                         if (match) {
//                             quantity = parseInt(match[0]);
//                             break;
//                         }
//                     }
//                 }
//             }

//             if (price > 0 && quantity) {
//                 let perUnit = (price / quantity).toFixed(2);
//                 discountPriceElement.innerText = `$${perUnit}`;
//             } else {
//                 discountPriceElement.innerText = "";
//             }
//         } else {
//             console.log("Missing price or unit display element.");
//         }
//     }

//     // Initial run on page load
//     updatePerUnitPrice();

//     // Event listener for variant selection
//     document.addEventListener("change", function (event) {
//         if (event.target.matches('input[type="radio"]')) {
//             const isModal = event.target.closest('.modal-content') !== null;
//             updatePerUnitPrice(isModal);
//         }
//     });

//     // When Quick Shop popup opens
//     document.addEventListener("click", function (event) {
//         if (event.target.matches(".quick-shop-button")) {
//             setTimeout(() => {
//                 updatePerUnitPrice(true); // Run after modal content loads
//             }, 500);
//         }
//     });
// });




// document.addEventListener("DOMContentLoaded", function () {
//     function updatePrices(modal = false) {
//         // Select correct price container (inside modal OR main page)
//         const priceElement = modal 
//             ? document.querySelector('.#current-price .price')
//             : document.querySelector('#current-price .price');

//         if (!priceElement) {
//             console.error("Price element not found.");
//             return;
//         }

//         const price = parseFloat(priceElement.innerText.replace(/[^0-9.]/g, ""));
//         console.log("Current Price:", price);

//         // Select the variant option (radio buttons inside modal OR main page)
//         const selectedRadioButton = modal 
//             ? document.querySelector('#current-price input[type="radio"]:checked')
//             : document.querySelector('input[type="radio"]:checked');

//         if (!selectedRadioButton) {
//             console.error("No radio button is selected.");
//             return;
//         }

//         let quantity = parseInt(selectedRadioButton.value);
//         console.log("Selected Size (ml):", quantity);

//         if (price > 0 && quantity > 0) {
//             const pricePerMl = price / quantity;
//             const perMlElement = modal 
//                 ? document.querySelector('.quick-shop-modal #per-ml-price')
//                 : document.querySelector("#per-ml-price");

//             if (perMlElement) {
//                 perMlElement.innerHTML = `$${pricePerMl.toFixed(2)}`;
//                 console.log("Price Per ml:", pricePerMl.toFixed(2));
//             } else {
//                 console.error("Price per ml element not found.");
//             }
//         } else {
//             console.warn("Price or quantity is not valid.");
//         }
//     }

//     // Run updatePrices on page load
//     updatePrices();

//     // Event listener for variant selection (handles both main page & modal)
//     document.addEventListener("change", function (event) {
//         if (event.target.matches('input[type="radio"]')) {
//             const isModal = event.target.closest('.quick-shop-modal') !== null;
//             updatePrices(isModal);
//         }
//     });

//     // Detect when the Quick Shop modal opens and update prices
//     document.addEventListener("click", function (event) {
//         if (event.target.matches(".quick-shop-button")) { 
//             setTimeout(() => {
//                 updatePrices(true); // Run after modal content loads
//             }, 500);
//         }
//     });
// });




